// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dock-outer {
  margin: 0 0.5rem;
  display: flex;
  max-width: 100%;
  align-items: flex-start; /* Changed from center to start for top anchoring */
  z-index: 100;
}

.dock-panel {
  position: absolute;
  top: 86px; /* 70px header + 16px gap */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: flex-start; /* Anchored to top */
  width: fit-content;
  gap: 1rem;
  border-radius: 1rem;
  background-color: var(--sidebar-bg, #120F17); /* Fallback to React Bits default but support theme */
  border: var(--glass-border, 1px solid #333);
  padding: 0.5rem 0.5rem 0; /* Padding on top */
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  backdrop-filter: var(--glass-blur, blur(16px));
}

.dock-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background-color: var(--surface-light, #1e1b2e);
  border: var(--glass-border, 1px solid #333);
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.2),
    0 2px 4px -1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  outline: none;
  color: var(--text-main, white);
}

.dock-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dock-label {
  position: absolute;
  bottom: -2.5rem; /* Dropping downwards */
  left: 50%;
  width: fit-content;
  white-space: pre;
  border-radius: 0.375rem;
  border: var(--glass-border, 1px solid #444);
  background-color: var(--bg-card, #120F17);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  color: var(--text-main, #fff);
  transform: translateX(-50%);
  z-index: 101;
}

.dock-item:hover, .dock-item.active {
    background-color: var(--accent-light, rgba(168, 85, 247, 0.1));
    border-color: var(--accent-color, #a855f7);
    color: var(--accent-color, #a855f7);
}

/* Light Mode Overrides for Dock */
html[data-theme='light'] .dock-panel {
  background: rgba(238, 242, 246, 0.8); /* Light greyish blue / off-white */
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 1);
}

html[data-theme='light'] .dock-item {
  background-color: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  color: var(--text-secondary);
}

html[data-theme='light'] .dock-item:hover {
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: var(--text-main);
}

html[data-theme='light'] .dock-item.active {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  color: var(--accent-color, #a855f7);
}

html[data-theme='light'] .dock-label {
  background-color: rgba(255, 255, 255, 0.95);
  color: #1e293b;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dock.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB,EAAE,mDAAmD;EAC5E,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,2BAA2B;EACtC,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB,EAAE,oBAAoB;EAC7C,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,4CAA4C,EAAE,qDAAqD;EACnG,2CAA2C;EAC3C,wBAAwB,EAAE,mBAAmB;EAC7C,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,2CAA2C;EAC3C;;qCAEmC;EACnC,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,uBAAuB;EACxC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;EAC3C,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;IACI,8DAA8D;IAC9D,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC,EAAE,mCAAmC;EACzE,qCAAqC;EACrC,iFAAiF;AACnF;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,qCAAqC;EACrC,yCAAyC;AAC3C","sourcesContent":[".dock-outer {\n  margin: 0 0.5rem;\n  display: flex;\n  max-width: 100%;\n  align-items: flex-start; /* Changed from center to start for top anchoring */\n  z-index: 100;\n}\n\n.dock-panel {\n  position: absolute;\n  top: 86px; /* 70px header + 16px gap */\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: flex-start; /* Anchored to top */\n  width: fit-content;\n  gap: 1rem;\n  border-radius: 1rem;\n  background-color: var(--sidebar-bg, #120F17); /* Fallback to React Bits default but support theme */\n  border: var(--glass-border, 1px solid #333);\n  padding: 0.5rem 0.5rem 0; /* Padding on top */\n  box-shadow: 0 10px 25px rgba(0,0,0,0.2);\n  backdrop-filter: var(--glass-blur, blur(16px));\n}\n\n.dock-item {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background-color: var(--surface-light, #1e1b2e);\n  border: var(--glass-border, 1px solid #333);\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.2),\n    0 2px 4px -1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  outline: none;\n  color: var(--text-main, white);\n}\n\n.dock-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dock-label {\n  position: absolute;\n  bottom: -2.5rem; /* Dropping downwards */\n  left: 50%;\n  width: fit-content;\n  white-space: pre;\n  border-radius: 0.375rem;\n  border: var(--glass-border, 1px solid #444);\n  background-color: var(--bg-card, #120F17);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  color: var(--text-main, #fff);\n  transform: translateX(-50%);\n  z-index: 101;\n}\n\n.dock-item:hover, .dock-item.active {\n    background-color: var(--accent-light, rgba(168, 85, 247, 0.1));\n    border-color: var(--accent-color, #a855f7);\n    color: var(--accent-color, #a855f7);\n}\n\n/* Light Mode Overrides for Dock */\nhtml[data-theme='light'] .dock-panel {\n  background: rgba(238, 242, 246, 0.8); /* Light greyish blue / off-white */\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 1);\n}\n\nhtml[data-theme='light'] .dock-item {\n  background-color: rgba(255, 255, 255, 0.4);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n  color: var(--text-secondary);\n}\n\nhtml[data-theme='light'] .dock-item:hover {\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: var(--text-main);\n}\n\nhtml[data-theme='light'] .dock-item.active {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  color: var(--accent-color, #a855f7);\n}\n\nhtml[data-theme='light'] .dock-label {\n  background-color: rgba(255, 255, 255, 0.95);\n  color: #1e293b;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
